import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {WorkflowPdfComponent} from "./workflow-pdf/workflow-pdf.component";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {
  MatButtonModule, MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule,
  MatInputModule, MatListModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSelectModule, MatSnackBarModule, MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule, MatTooltipModule
} from "@angular/material";
import {AppRoutingModule} from "../../app-routing.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {FileuploadModule} from "../../fileupload/fileupload.module";
import {FileSizeModule} from "ngx-filesize";
import {WorkflowStepDriversManualComponent} from "./workflow-step-drivers-manual.component";
import {WorkflowMetadataComponent} from "./workflow-metadata/workflow-metadata.component";
import {WorkflowXmlComponent} from "./workflow-xml/workflow-xml.component";
import {WorkflowImagesComponent} from "./workflow-images/workflow-images.component";
import {WorkflowLangxmlComponent} from "./workflow-langxml/workflow-langxml.component";
import {AddLeadingZerosModule} from "../../pipes/add-leading-zeros.module";
import {SharedModule} from "../../shared/shared.module";

@NgModule({
  declarations: [
    WorkflowStepDriversManualComponent,
    WorkflowMetadataComponent,
    WorkflowXmlComponent,
    WorkflowLangxmlComponent,
    WorkflowPdfComponent,
    WorkflowImagesComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatTabsModule,
    AppRoutingModule,
    MatStepperModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    FileuploadModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    FileSizeModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatGridListModule,
    SharedModule,
    AddLeadingZerosModule.forRoot()
  ],
  exports: [
    WorkflowStepDriversManualComponent,
    WorkflowMetadataComponent,
    WorkflowXmlComponent,
    WorkflowLangxmlComponent,
    WorkflowPdfComponent,
    WorkflowImagesComponent
    ],
  providers: []
})
export class WorkflowStepDriversManualModule { }
